module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "office-detail-warp"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.companyDetailList.name))]), _vm._v(" "), _c('div', {
    staticClass: "cont-warp"
  }, [_c('div', {
    staticClass: "message-warp"
  }, [_c('h3', [_vm._v("办证室信息:")]), _vm._v(" "), _c('div', {
    staticClass: "title-messag"
  }, [_c('div', {
    staticClass: "category"
  }, [_vm._v("公证员")]), _vm._v(" "), _c('div', {
    staticClass: "pic-warp"
  }, [_c('div', {
    staticClass: "pic-w-inner",
    staticStyle: {
      "background-image": "url('static/images/ex_pic17.jpg')"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.companyDetailList.message.name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.companyDetailList.message.number))])])]), _vm._v(" "), _c('div', {
    staticClass: "today-all-number"
  }, [_c('h4', [_vm._v("今日办证总量")]), _vm._v("\n        " + _vm._s(_vm.companyDetailList.message.allNum) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "today-finish-number"
  }, [_c('h4', [_vm._v("今日已办数量")]), _vm._v("\n        " + _vm._s(_vm.companyDetailList.message.finNum) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "canmar-warp",
    class: {
      active: _vm.fullScreenSwite
    },
    on: {
      "click": _vm.fullScreen
    }
  }, [_c('canmar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "server-warp"
  }, [_c('h3', [_vm._v("业务办理中:")]), _vm._v(" "), _c('div', {
    staticClass: "server-list-warp"
  }, [_c('detail-list', {
    attrs: {
      "offDetailList": _vm.companyDetailList.list
    }
  })], 1)])]), _vm._v(" "), _c('a', {
    staticClass: "go-back",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goback(true)
      }
    }
  }, [_vm._v("×")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5af1d3ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/office-detail.vue
// module id = 181
// module chunks = 1